// src/routes/signin.tsx
import { SignInForm } from "@/auth/components/sign-in-form";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const signInSearchSchema = z.object({
	redirect: z.string().optional(),
});

export const Route = createFileRoute("/_public/_auth/sign-in")({
	validateSearch: signInSearchSchema,
	component: SignInPage,
});

function SignInPage() {
	const { redirect } = Route.useSearch();

	return (
		<div className="flex min-h-screen items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
			<div className="mx-auto w-full max-w-4xl">
				<SignInForm redirectUrl={redirect} />
			</div>
		</div>
	)
}
